"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLabel = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.StyledLabel = styled_components_1.default.label `
  font-family: ${({ theme }) => theme.typography.desktop.text.small_bold['font-family'].value};
  color: ${({ theme }) => theme.colors.colours.default['digital-black'].value};
  font-size: ${({ theme }) => theme.typography.desktop.text.small_bold['font-size'].value};
  line-height: ${({ theme }) => theme.typography.desktop.text.small_bold['line-height'].value};
  margin-bottom: ${({ theme }) => theme.sizes['2xs'].value};
  font-weight: ${({ theme }) => theme.typography.desktop.text.small_bold['font-weight'].value};
  display: inline-block;
  ${({ disabled }) => disabled &&
    (0, styled_components_1.css) `
      color: ${({ theme }) => theme.colors.colours.system['disable-light-theme'].value};
    `}
  ${({ required }) => required &&
    (0, styled_components_1.css) `
      &::after {
        content: ' *';
        color: ${({ theme }) => theme.colors.colours.system.fail.value};
      }
    `}
`;
//# sourceMappingURL=Label.styled.js.map